/**
 * Polyfills for modern browsers only (Chrome 55+, Firefox 54+, Safari 10+, Edge 15+)
 * Zone.js is required by Angular for change detection and async operations.
 */

/***************************************************************************************************
 * Zone JS - Required by Angular
 * Using modern zone.js entry point for better performance
 */
import 'zone.js';

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
